/* eslint-disable prettier/prettier */
import { Box, Flex, IconButton } from '@chakra-ui/react'
import React, {
  useEffect,
  useState,
  type ReactElement,
  useContext
} from 'react'
import { Link } from '../components/Link'
import LogoInline from '../components/logo'

import { Info } from 'lucide-react'
import { HamburgerIcon } from '@chakra-ui/icons'
import IntroModal from '../components/IntroModal'
import { RoomSettingsContext } from '../pages/+RoomSettingsContext'

const Navigation = (props: { hasSidebar?: boolean }): ReactElement => {
  const { hasSidebar } = props
  const [isTop, setIsTop] = useState(true)
  const { roomSettings, showIntroModal, setShowIntroModal } =
    useContext(RoomSettingsContext)

  const handleScroll = (): void => {
    setIsTop(window.scrollY === 0)
  }

  const openMenu = (): void => {
    window?.openDrawer?.toggle()
  }
  let mobileNoNav = 'false'
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    const mobileNoNavParam = params.get('mobileNoNav')
    mobileNoNav =
      mobileNoNavParam !== null && mobileNoNavParam !== ''
        ? mobileNoNavParam
        : 'false'
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Box
      as="header"
      sx={{
        position: 'sticky',
        top: 0,
        bg: 'white',
        '&': !isTop
          ? {
              boxShadow: 'xs'
            }
          : {},
        zIndex: '1500',
        '& .navitem': {
          opacity: roomSettings?.options?.hideNavigation.value === true ? 0 : 1,
          transition: 'opacity 0.5s'
        }
      }}
    >
      <Flex
        maxW="1296px"
        mx="auto"
        pr="48px"
        py="10px"
        pos="relative"
        gap="2px"
        justifyContent="center"
        alignItems="center"
      >
        <Logo />
        <Box
          as={Link}
          className="navitem"
          href="/#home"
          display={{ base: 'none', md: 'flex' }}
        >
          Home
        </Box>
        <Box
          as={Link}
          className="navitem"
          href="/#activities"
          display={{ base: 'none', md: 'flex' }}
        >
          Activities
        </Box>
        <Box
          as={Link}
          className="navitem"
          href="/#about"
          display={{ base: 'none', md: 'flex' }}
        >
          About
        </Box>

        <Box as={Link} className="navitem" href="/join">
          Join Room
        </Box>
        <Flex pos="absolute" right="10px" gap="10px">
          {hasSidebar !== true ||
            (roomSettings !== null && (
              <IconButton
                bg="yellow.300"
                as="button"
                borderRadius={0}
                aria-label="open menu"
                icon={
                  <div>
                    <Info />
                    <div className="bend" />
                  </div>
                }
                onClick={() => {
                  setShowIntroModal(!showIntroModal)
                }}
                sx={{
                  '&:hover': {
                    bg: 'yellow.400',
                    '& .bend': {
                      position: 'absolute',
                      bg: 'white',
                      bottom: '0px',
                      right: '0px',
                      borderStyle: 'solid',
                      h: 'auto',
                      aspectRatio: '1/1',
                      w: '10px',
                      boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
                      zIndex: 2,
                      overflow: 'hidden',
                      '&:after': {
                        pointerEvents: 'none',
                        color: 'yellow.100',
                        background:
                          'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
                        content: '""',
                        display: 'block',
                        pos: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                      },
                      button: {
                        pos: 'absolute',
                        right: '20px',
                        bottom: '20px'
                      }
                    }
                  }
                }}
              />
            ))}
          {hasSidebar === true && (
            <IconButton
              bg="yellow.300"
              as="button"
              borderRadius={0}
              aria-label="open menu"
              icon={
                <div>
                  <HamburgerIcon />
                  <div className="bend" />
                </div>
              }
              onClick={openMenu}
              sx={{
                '&:hover': {
                  bg: 'yellow.400',
                  '& .bend': {
                    position: 'absolute',
                    bg: 'white',
                    bottom: '0px',
                    right: '0px',
                    borderStyle: 'solid',
                    h: 'auto',
                    aspectRatio: '1/1',
                    w: '10px',
                    boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
                    zIndex: 2,
                    overflow: 'hidden',
                    '&:after': {
                      pointerEvents: 'none',
                      color: 'yellow.100',
                      background:
                        'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
                      content: '""',
                      display: 'block',
                      pos: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0
                    },
                    button: {
                      pos: 'absolute',
                      right: '20px',
                      bottom: '20px'
                    }
                  }
                }
              }}
            />
          )}
        </Flex>
      </Flex>
      {roomSettings !== null && (
        <IntroModal
          isOpen={showIntroModal}
          activity={roomSettings.activity}
          onClose={() => {
            localStorage.setItem(
              `${String(roomSettings.activity.slug)}-intro`,
              'false'
            )
            setShowIntroModal(false)
          }}
        >
          Intro
        </IntroModal>
      )}
    </Box>
  )
}

export default Navigation

const Logo = (): ReactElement => (
  <Box as={Link} title="Reactvts" href="/" noHover>
    <Box as={LogoInline} aria-label="Reactvts" w="73px" />
  </Box>
)
